"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const images_1 = require("../../../services/images");
const react_i18next_1 = require("react-i18next");
const DedicatedRowWeb = ({ dedicated }) => {
    const [t] = (0, react_i18next_1.useTranslation)("i18n", { keyPrefix: "details" });
    return ((0, jsx_runtime_1.jsxs)("p", { className: "font-14-400 iconed", children: [(0, jsx_runtime_1.jsx)("img", { src: dedicated ? images_1.icons.DedicatedFlightCircled : images_1.icons.SharedFlightCircled, alt: "" }), dedicated ? t("dedicated_flight") : t("shared_flight")] }));
};
exports.default = DedicatedRowWeb;
